import {useQuery} from '@tanstack/react-query'
import {BlogPost, fetchBlogPosts} from '../blogPosts'
import {getLogger} from '../logUtils'

/**
 * React Query hook to fetch blog posts from WordPress API
 * @param limit - Maximum number of posts to fetch (default: 4)
 * @returns Query result with blog posts data
 */
export const useBlogPosts = (limit: number = 4) => {
  return useQuery<BlogPost[], Error>(
    ['blogPosts', limit],
    () => fetchBlogPosts(limit),
    {
      staleTime: 1000 * 60 * 60, // Cache for 1 hour
      cacheTime: 1000 * 60 * 60 * 2, // Keep in cache for 2 hours
      retry: 2, // Retry twice on failure
      retryDelay: 1000, // Wait 1 second between retries
      onError: (error) => {
        getLogger().error('Error fetching blog posts:', error)
      },
    }
  )
}


